// extracted by mini-css-extract-plugin
export default {"container":"wH-z","header":"xH-z","details":"yH-z","link":"zH-z"};